export default {
  defaultStyle: {
    '&:lang(ar)': {
      direction: 'rtl'
    }
  },
  defaultFlyHotel: {
    marginTop: '0',
    marginBottom: '17px',
    padding: '0'
  },
  travelOptions: {
    textAlign: 'center',
    font: data => '13px ' + data.fontFamily1,
    marginBottom: '20px',
    borderBottom: '1px solid #fff',
    '@media (min-width: 801px)': {
      marginBottom:'0',
      borderBottom: '0',
      fontSize: '16px',
      textTransform: 'uppercase',
      letterSpacing: '1px',
      textAlign: 'left',
      padding: '0 0 0 20px',
      position:'relative',
      boxSizing:'border-box',
      flexGrow:'1',
      '&:lang(ar)': {
        padding: '0 20px 0 0'
      }
    },
    '&:lang(ar)': {
      '@media (min-width: 801px)': {
        textAlign: 'right'
      }
    }
  },
  travelOptionsContainer: {
    display: 'flex',
    alignItems:'flex-end',
    flexWrap:'nowrap',
    width: '100%',
    borderBottomColor: 'rgba(255,255,255,.5)',
    '@media (min-width: 801px)': {
      borderBottom: 'none',
      display:'table',
    }
  },
  travelOptionsContent: {
    minWidth:'110px',
    paddingBottom: '5px',
    position:'relative',
    '@media (min-width:801px)': {
      paddingLeft:'35px',
      minWidth:'auto',
      paddingBottom:'0',
      display:'table-cell',
      verticalAlign:'middle',
      '&:lang(ar)': {
        paddingLeft: '0',
        paddingRight: '35px'
      }
    }
  },
  travelOptionsContentFly: {
    color: '#fff',
    cursor: 'pointer',
    minWidth:'100px',
    padding: '0 10px 5px 0',
    position:'relative',
    '@media (min-width:801px)': {
      paddingLeft:'37px',
      paddingRight:'20px',
      paddingBottom:'10px',
      minWidth:'auto',
      '&:lang(ar)': {
        paddingLeft: '20px',
        paddingRight: '37px',
      }
    }
  },
  travelOptionsText: {
    color: data => data.engineColorFont,
    letterSpacing: '.5px',
    textDecoration: 'none',
    font: data => '13px ' + data.fontFamily1,
    '&:after': {
      content: `''`,
      position: 'absolute',
      left: '0',
      right: '0',
      bottom: '0',
      height:'3px',
      backgroundColor:data => data.engineColorFont,
      zIndex: 1
    },
    '@media (min-width: 801px)': {
      fontSize: '16px'
    }
  },
  travelOptionsIcon: {
    fontSize: '22px',
    lineHeight: '23px',
    display: 'block',
    textAlign:'center',
    marginBottom:'3px',
    '&:lang(ar)': {
      marginLeft: '8px',
      marginRight: '0'
    },
    '@media (min-width: 801px)': {
      position:'absolute',
      left:'5px',
      top:'50%',
      marginBottom:0,
      marginTop:'-15px',
      '&:lang(ar)': {
        left: 'auto',
        right: '5px',
      }
    }
  },
  travelOptionsIconGold: {
    composes: '$travelOptionsIcon',
    color: data => data.engineColorFont,
    fontSize: '26px'
  },
  travelOptionsIconSlide:{
    composes: '$travelOptionsIcon',
    opacity:'.6',
    '@media (min-width: 801px)': {
      marginTop:'-18px'
    }
  },
  travelOptionsTextFly: {
    composes: '$travelOptionsText',
    color: '#fff',
    opacity: '.6',
    '&:hover': {
      textDecoration: 'none',
      '@media (min-width:801px)': {
        color: data => data.engineColorFont,
        transition: 'all .3s'
      }
    },
    '&:after': {
      content: 'none'
    },
    '& > span':{
      whiteSpace:'nowrap'
    }
  },
  moreOptionsContainer: {
    //overflow:'hidden',
    position:'relative',
    '@media (min-width: 801px)': {
      padding: '20px 20px 0 0',
      borderBottom: '1px solid #fff',
      borderBottomColor: 'rgba(255,255,255,.5)',
      width: '100%',
      boxSizing: 'border-box',
      display:'table'
    },
  },
  shortedSlide:{},
  slideButtonContainer:{
    position:'relative',
    padding:'0 30px',
    display:'table-cell',
    verticalAlign:'middle',
    '@media (max-width: 800px)': {
      overflowY:'scroll',
      msOverflowStyle: 'none',
      scrollbarWidth:'none',
      padding:'0 10px',
      '&::-webkit-scrollbar':{
        display:'none'
      },
    },
    '@media (min-width: 801px)': {
      maxWidth:'190px',
      width:'100%'
    },
    '@media (min-width: 901px)': {
      maxWidth:'280px'
    },
    '@media (min-width: 1001px)': {

      maxWidth:'370px'
    },
    '&$shortedSlide':{
      '@media (min-width: 1001px)': {
        maxWidth:'280px'
      }
    },
  },
  multiSlide:{
    '@media (min-width: 801px)': {
      padding: '10px 20px 0 0',
      display:'flex',
      alignItems:'center',
      justifyContent:'space-between'
    },
    '&:lang(ar)':{
      '@media (min-width: 801px)': {
        paddingLeft:'20px',
        paddingRight:'0'
      }
    }
  },
  monoSlide:{
    padding:0,
    '& $travelOptionsContent':{
      '@media (max-width:800px)':{
        padding:'10px'
      }
    },
    '& $travelOptionsContentFly':{
      '@media (max-width:800px)':{
        padding:'10px'
      }
    },
    '& $travelOptionsIcon':{
      '@media (max-width:800px)':{
        display:'inline-block',
        verticalAlign:'middle',
        margin:'-5px 8px 0 0',
        '&:lang(ar)': {
          margin: '-5px 0 0 8px'
        }
      }
    },
    '@media (min-width: 801px)': {
      padding: '10px 20px 0 0',
      '&:lang(ar)': {
        padding: '10px 0 0 20px',
      }
    }
  }
};
